import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=608a8b84&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=608a8b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a8b84",
  null
  
)

export default component.exports